import React from 'react'
import './Footer.scss'

function Footer() {
  return (
    <div className="footerContainer">
      <p>
        Designed by{' '}
        <a
          href="https://lonkansoft.pro/"
          target="_blank"
          rel="noreferrer"
        >
          <b>ITALO</b>
        </a>
      </p>
    </div>
  )
}

export default Footer
